import React from 'react';
import styled from 'styled-components';
import Card from './Card';

function Widget({id, preview, title, children, options, ...props}) {
  return (
    <Card {...props}>
      <WidgetContent>
        {children}
      </WidgetContent>
    </Card>
  );
}

const WidgetContent = styled.div`
  height: 43.75rem;
`;

export default Widget;